export default __webpack_public_path__ + "static/media/ic_add.697285c2.svg";